import { DEBUG_CONFIG } from '../config.js';
import { debugFactory } from '@iva/debugger';
// Use the parameter ?sznivadbg=1 for debugging
const debug = debugFactory(DEBUG_CONFIG);
export { debug };
